import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var ChevronDown = function ChevronDown(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9893 18.2812C12.4512 18.2812 12.8486 18.0986 13.2031 17.7441L21.249 9.49414C21.5283 9.21484 21.6787 8.87109 21.6787 8.46289C21.6787 7.625 21.0127 6.95898 20.1855 6.95898C19.7773 6.95898 19.3906 7.12012 19.0898 7.4209L12 14.7256L4.89941 7.4209C4.59863 7.13086 4.22266 6.95898 3.80371 6.95898C2.97656 6.95898 2.31055 7.625 2.31055 8.46289C2.31055 8.87109 2.46094 9.21484 2.74023 9.50488L10.7861 17.7441C11.1621 18.1094 11.5381 18.2812 11.9893 18.2812Z"
  })));
};

ChevronDown.displayName = 'ChevronDown';
export default ChevronDown;